import React from "react";

// Section opener shared by the lower sections: a two-line headline in the
// hero's display style on the left, the lede sitting on its baseline to the
// right. No eyebrow, no rule, no marker: the type does the work.
export default function SectionHeader({ title, lede }) {
  return (
    <div className="grid lg:grid-cols-12 gap-6 lg:gap-16 items-end">
      <h2 className="lg:col-span-7 font-medium tracking-tighter leading-[0.95] text-white text-[clamp(2.25rem,5vw,4.5rem)]">
        {title[0]}
        <br />
        {title[1]}
      </h2>
      <p className="lg:col-span-5 max-w-xl text-base lg:text-lg leading-relaxed text-white/80">
        {lede}
      </p>
    </div>
  );
}
